var _a;
export var CUSTOM_FACTOR_VALUE = 'Custom';
export var SHRINKAGE_FACTOR_I18N_KEYS = {
  'Paid Breaks': 'paidBreaks',
  Coaching: 'coaching',
  Meetings: 'meetings',
  Custom: 'custom',
  Vacation: 'vacation',
  'Bank/Statutory Holidays': 'bankStatutoryHolidays',
  Absenteeism: 'absenteeism',
  'Short-term Leave': 'shortTermLeave'
};
export var SHRINKAGE_CATEGORY_OUT_OF_OFFICE = 'out_of_office';
export var SHRINKAGE_CATEGORY_IN_OFFICE = 'in_office';
export var PREDEFINED_SHRINKAGE_FACTORS = (_a = {}, _a[SHRINKAGE_CATEGORY_OUT_OF_OFFICE] = ['Vacation', 'Bank/Statutory Holidays', 'Absenteeism', 'Short-term Leave', CUSTOM_FACTOR_VALUE], _a[SHRINKAGE_CATEGORY_IN_OFFICE] = ['Paid Breaks', 'Coaching', 'Meetings', CUSTOM_FACTOR_VALUE], _a);